<template>
  <!-- 首页并且首页配置为透明底的时候不需要背景色 -->
  <div
    class="headbox"
    custom_class="headerAllThemeBtnClass"
    :class="{
      'menu_background_color': !transparentHead || pathName !== '/',
      'scroll-down-hidden': headerConfig.visibility == 'float'&& scrollMethod == 'down',
      'menu--on-top menu_background_color': loading && windowScrollY,
      'menu--on-top':  fixd_top
    }"
    :style=" addCartAnimation ? {
      opacity: 1,
      top:0
    }:{}"
  >
    <!-- 顶部信息 -->
    <div
      class="indexwrapheadtitle container"
      :class="{
        'indexmodule': indexmodule && onSuspension,
        'menu--on-top menu_background_color': loading && windowScrollY,
        'menu--on-top': home_fixd_top
      }"
      :style="{
        'background-color':home_fixd_top ? headerConfig.menu_background_color : 'rgba(200, 54, 54, 0)'
      }"
    >
      <div class="titlemenu">
        <a
          href="/"
          class="iconfont icon-i-Menu menu_icon_color"
          @click.prevent.stop="showleftmenu"
        ></a>
        <!-- <a
          href="/"
          class="iconfont icon-cm-cancel-1-copy menu_icon_color"
          @click.prevent="hiddenleftmenu"
          v-else
        ></a> -->
      </div>
      <div class="titleleft">
        <a href="/" class="menu_icon_color">
          <img
            v-if="titleLogo"
            :src="titleLogo"
            :style="{ 'max-width': logoMaxWidth + 'px !important' }"
            :alt="title"
            @load="mainmenu.length && hiddenmenu()"
          />
          <span class="title_font2" v-else>{{ title }}</span>
        </a>
      </div>
      <ul class="titleright">
        <li v-if="mainmenu && mainmenu.length">
          <a
            v-for="item in mainmenu"
            :key="item && item.ID"
            :href="item.path || item.url"
            class="secondary_title menu_icon_color"
            :class="
              item.children && item.children.length
                ? 'textnav has_child_menu'
                : 'textnav'
            "
          >
            {{ item.title }}
            <i
              v-if="item.children && item.children.length"
              class="iconfont icon-sanjiaodown"
            ></i>
            <ul v-if="item.children && item.children.length">
              <li style="height: 10px" @click.prevent></li>
              <li v-for="subitem in item.children" :key="subitem.id">
                <a
                  :href="subitem.path || subitem.url"
                  class="secondary_title menu_icon_color"
                  :class="
                    subitem.children.length
                      ? 'textnav has_child_menu has_third_menu'
                      : 'textnav'
                  "
                  >{{ subitem.title }}
                  <i
                    v-if="subitem.children.length"
                    class="iconfont icon-sanjiaodown"
                  ></i>
                  <ul v-if="subitem.children.length">
                    <li style="height: 10px" @click.prevent></li>
                    <li
                      v-for="subitemchildren in subitem.children"
                      :key="subitemchildren.id"
                    >
                      <a
                        :href="subitemchildren.path || subitemchildren.url"
                        class="secondary_title menu_icon_color"
                        >{{ subitemchildren.title }}</a
                      >
                    </li>
                    <li style="height: 10px" @click.prevent></li>
                  </ul>
                </a>
              </li>
              <li style="height: 10px" @click.prevent></li>
            </ul>
          </a>
        </li>
        <!-- default主题菜单栏：货币切换 -->
        <li v-if="showCurrencySelector && currencySelectorType == 'menu'" class="currency-selector">
          <v-selectprice model="default" :noprice="true" :append-to-body="false" ></v-selectprice>
        </li>
        <li v-if="checkoutMemberConfig != 'guest'">
          <a :href="login_status ? '/account' : '/account/login'" class="iconfont icon-i-Account menu_icon_color">
            <span class="fallback-text secondary_title">account</span>
          </a>
        </li>
        <li>
          <a
            href="/search"
            class="iconfont icon-i-Search menu_icon_color"
            @click.prevent="showMasked"
          >
            <span class="fallback-text secondary_title">search</span>
          </a>
        </li>
        <li v-if="cartType == 'drawer'">
          <a
            href="/cart"
            class="iconfont icon-a-i-ShoppingCart menu_icon_color"
            @click.prevent="showCart"
            style="font-weight: 600"
          >
            <div :class="{'animation-product-to-cart':loading }" style="display:none">
              <div class="xAxis">
                <div class="yAxis">
                  <svg t="1641872786742" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6405" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" style=" fill: #a26b25;" >
                    <path d="M505.7536 0.8192a241.5104 241.5104 0 0 1 241.5104 241.5104h150.272c21.1456 0 38.7072 16.384 40.1408 37.5296l48.128 697.6512a40.2432 40.2432 0 0 1-40.1408 43.008H65.8432a40.2432 40.2432 0 0 1-40.1408-43.008l48.128-697.6512a40.2432 40.2432 0 0 1 40.1408-37.5296H264.192A241.5104 241.5104 0 0 1 505.7536 0.8192zM287.488 602.2656a40.2432 40.2432 0 0 0-33.6384 62.3616 295.0144 295.0144 0 0 0 251.904 141.2608 294.912 294.912 0 0 0 251.904-141.2608 40.2432 40.2432 0 1 0-68.7104-41.984 214.528 214.528 0 0 1-183.1936 102.7072A214.528 214.528 0 0 1 322.56 622.6432a40.3456 40.3456 0 0 0-35.072-20.3776zM505.7536 81.3568a161.024 161.024 0 0 0-161.024 160.9728h322.048A161.024 161.024 0 0 0 505.7536 81.408z" p-id="6406"></path>
                  </svg>
                </div>
              </div>
            </div>
            <span class="fallback-text secondary_title">cart</span>
            <!--页面刷新时会传入购物车数量，vuex里的值默认为是为真的，所以一般情况下第一个值就觉得是否显示。只有当购物车页面使用api删除购物车的商品时才会使vuex里的值可能为假 -->
            <span
              class="cart_dot default_num"
              :class="[{default_big_num: cartContentsCount>99}]"
            >{{cartContentsCount>99 ? '99+' : cartContentsCount}}</span>
          </a>
        </li>
        <li v-else>
          <a
            href="/cart"
            class="iconfont icon-24gf-cart7 menu_icon_color"
            style="font-weight: 600"
          >
            <div :class="{'animation-product-to-cart':loading }" style="display:none">
              <div class="xAxis">
                <div class="yAxis">
                  <svg t="1641872786742" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6405" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" style="fill: #a26b25;" >
                    <path d="M505.7536 0.8192a241.5104 241.5104 0 0 1 241.5104 241.5104h150.272c21.1456 0 38.7072 16.384 40.1408 37.5296l48.128 697.6512a40.2432 40.2432 0 0 1-40.1408 43.008H65.8432a40.2432 40.2432 0 0 1-40.1408-43.008l48.128-697.6512a40.2432 40.2432 0 0 1 40.1408-37.5296H264.192A241.5104 241.5104 0 0 1 505.7536 0.8192zM287.488 602.2656a40.2432 40.2432 0 0 0-33.6384 62.3616 295.0144 295.0144 0 0 0 251.904 141.2608 294.912 294.912 0 0 0 251.904-141.2608 40.2432 40.2432 0 1 0-68.7104-41.984 214.528 214.528 0 0 1-183.1936 102.7072A214.528 214.528 0 0 1 322.56 622.6432a40.3456 40.3456 0 0 0-35.072-20.3776zM505.7536 81.3568a161.024 161.024 0 0 0-161.024 160.9728h322.048A161.024 161.024 0 0 0 505.7536 81.408z" p-id="6406"></path>
                  </svg>
                </div>
              </div>
            </div>
            <span
              class="cart_dot default_num"
              :class="[{ default_big_num: cartContentsCount>99}]"
            >{{cartContentsCount>99 ? '99+' : cartContentsCount }}</span>
            <span class="fallback-text secondary_title">cart</span>
          </a>
        </li>
      </ul>
    </div>
    <!-- 搜索框 -->
    <transition>
      <div
        class="Masked"
        v-show="Masked"
        @click="hiddenMasked"
        @keyup.esc="hiddenMasked"
      >
        <div class="searchinput">
          <i class="iconfont icon-cm-cancel-1-copy"></i>
          <input
            ref="searchinput"
            type="text"
            class="secondary_title"
            :placeholder="$t('home.search_our_store')"
            v-model="search"
            @click.stop
            @keyup.enter="searchproducts()"
            autocomplete
            name="q"
          />
          <span class="iconfont" @click.stop="searchproducts">&#xe618;</span>
        </div>
      </div>
    </transition>

    <!-- 左边拉出抽屉 -->
    <drawer-menu
      :menus="mainmenu"
      :secondary-menu="secondary_menu"
      :login-status="!!login_status"
      :visible="showLeftDreaMenu"
      :append-to-body="true"
      :cartStyle="cartStyle" 
      @close="hiddenleftmenu"
    />

    <!-- 抽屉式购物车 -->
    <v-default-drawer-cart v-if="cartType == 'drawer'"
    :showDrawer="showDrawer"
    :hiddenCart="hiddenCart"
    :cartStyle="cartStyle"
    :cart_loading="cart_loading"
    :cartmes="cartmes"
    :theme="theme"
    :showCurrencySelector="showCurrencySelector"
    :complete_subtotal="complete_subtotal"
    :currencySelectorType="currencySelectorType"
    :changequantity="changequantity"
    :checkout="checkout"
    :themeStyleRadius="themeStyleRadius"
    :comment="comment"
    :beforeAdd="beforeAdd"
    :recommended_product="recommended_product"
    :product_ids="product_ids"
    :cartNotOff="cartNotOff"
    :scrollerBack="scrollerBack"
    :show_recommended="show_recommended"
    :disabled_num="disabled_num"
    :checkout_active="checkout_active"
    ></v-default-drawer-cart>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import vDefaultDrawerCart from "@/js/components/common/defaultDrawerCart.vue"
import DrawerMenu from '../DrawerMenu.vue';
export default {
  props: [
    "comment",
    "indexmodule",
    "login_status",
    "cart",
    "mainmenu",
    "secondary_menu",
    "pixel_conversion",
    "recommended_product",
  ],
  data() {
    return {
      Masked: false, //遮罩层的显示
      search: "", //搜索商品
      isLogin: "",
      titleleftwidth: 0,
      titlerightwidth: 0,
      titlewidth: 0,
      checkout_active: false, // checkout 按钮的loading动画
      cart_loading: false,
      disabled_num: false,
      cartmes: {}, //购物车信息
      show_recommended: false, // 显示推荐
      showDrawer: false, // 显示购物车
      cartItemHeight: 0,
      onSuspension: true,
      pathName: window.location.pathname,
      home_fixd_top: false, // 首页 && 透明标题 悬浮顶部样式
      fixd_top: false, // 非首页 || 非透明标题 悬浮顶部样式
      titlemenulistShow: false,
      showLeftDreaMenu: false
    };
  },
  methods: {
    // 点击checkout out按钮
    async checkout() {
      let cart_hash = this.getCookie("cart_hash");
      this.checkout_active = true;

      let cart_item = Object.values(this.cartmes.cart);
      let content_ids = [];
      let product_category_ids = [];
      cart_item.forEach((item) => {
        content_ids.push(item.product_id);
        if (item.category_ids) {
          product_category_ids = product_category_ids.concat(item.category_ids);
        }
      });
      if (window.fbq) {
        if (
          this.pixel_conversion &&
          this.pixel_conversion.pixel_conversion &&
          this.pixel_conversion.pixel_conversion.length &&
          product_category_ids.length
        ) {
          this.initFBevent(
            this.pixel_conversion.pixel_conversion,
            product_category_ids
          );
        }
        this.send_fb_event("InitiateCheckout", {
          content_type: "product_group",
          content_ids,
          value: this.cartmes.cart_total,
          num_items: this.cartmes.cart_contents_count,
          currency: this.cartmes.currency ? this.cartmes.currency : "USD",
        });
      }
      if (window.ttq && window.send_ttp_event) {
        window.send_ttp_event('InitiateCheckout')
      }
      if (window._learnq) {
        this.klaviyo_checkout(this.cartmes);
      }
      // if (window.snaptr) {
      //     window.snaptr('track', 'START_CHECKOUT', {
      //         'currency': this.cartmes.currency ? this.cartmes.currency : "USD",
      //         'item_category': null,
      //         'item_ids': this.content_ids,
      //         'number_items': this.cartmes.cart_contents_count,
      //         'price': this.cartmes.cart_total,
      //     })
      // }

      this.$axios.post(API.statis_event, {
        name: "cart.check",
        parameters: { url: window.location.href },
      });
      this.$axios.post(API.statis_event, {
        name: "checkout.check",
        parameters: { url: window.location.href },
      });

      // if (window.gtag) {
      //   window.gtag("event", "cart.check");
      // }

      setTimeout(() => {
        this.checkout_active = false;
      }, 3000);
      this.toCheckInfo(cart_hash);
      // window.open(`/checkouts/${cart_hash}`, "_self");
    },

    // 修改数量， 或删除商品
    async changequantity(e, key) {
      e = this.filterinputnum(e, 0);
      this.cartmes.cart[key].quantity = e;
      try {
        this.disabled_num = true;
        var res = await this.$axios.put(API.changequantity + key, {
          quantity: e,
        });
        this.$store.dispatch("change_news_cart", res.data);
        this.cartmes = res.data;
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
        this.disabled_num = false;
      } catch (error) {
        this.disabled_num = false;
        if (
          error?.response?.data?.errors
        ) {
          console.log('/////////',Object.values(error.response.data.errors)[0][0])
          this.$message.error(Object.values(error.response.data.errors)[0][0]);
        }else if (
          error?.response?.data?.message
        ) {
          this.$message.error(error.response.data.message);
        }
      }
    },

    // 打开购物车卡片
    async showCart(event) {
      this.showDrawer = true;

      this.$("body").css({ overflow: "hidden" });

      // this.$(".titlerightcart").animate({ right: "0px" }, 300);
      // 是否加载数据
      if (event) {
        this.cart_loading = true;
        try {
          let res = await this.$axios.get(API.addcart + "?" + Math.random());
          this.cartmes = res.data;
        } catch (error) {
          if (
            error?.response?.data?.message
          ) {
            this.$message.error(error.response.data.message);
          }
        }
        this.cart_loading = false;
      }
    },

    // 关闭卡片
    hiddenCart(event) {
      this.showDrawer = false;
      let window_width =
        this.screenWidth > 590
          ? this.screenWidth
          : this.screenWidth + 100;
      if (
        event.target.className == "iconfont icon-cm-cancel-1-copy" ||
        window_width - event.clientX > 400
      ) {
        event.stopPropagation();
        event.preventDefault();
        this.$("body").css({ overflow: "" });
        this.$store.dispatch("change_cart_type", false);
        this.cart_loading = false;
      }
    },

    /**
     * 展开左边菜单
     *  */
    showleftmenu() {
      this.showLeftDreaMenu = true

      this.$("body").css({ overflow: "hidden" });

      // 快捷加购同样向右位移
      if(this.$(".quickPurchased")){
        this.$(".quickPurchased").animate({ left: "300px" }, 400)
      }
    },
    /**
     * 关闭左边菜单
     */
    hiddenleftmenu(event) {
      this.showLeftDreaMenu = false;
      event.stopPropagation();
      event.preventDefault();

      if(this.$(".quickPurchased")){
        this.$(".quickPurchased").animate({ left: "0" }, 300)
      }

      this.$("body").css({ overflow: "" });
      this.$(".pricelist").css("display", "none");
    },
    showMasked() {
      this.$("body").css({ overflowY: "hidden" });
      this.Masked = true;
      setTimeout(() => {
        this.$refs.searchinput.focus();
      }, 100);
    },
    hiddenMasked() {
      this.$("body").css({ overflowY: "" });
      this.Masked = false;
    },
    searchproducts() {
      this.send_fb_event("Search", { search_string: this.search });
      if (window.ttq && window.send_ttp_event) {
        window.send_ttp_event('Search',{query:this.search})
      }
       //搜索时snapchat的 SEARCH 事件
      if(window.snaptr){
        window.snaptr('track', 'SEARCH',{'search_string':this.search_string})
      }
      window.open("/search?q=" + encodeURIComponent(this.search), "_self");
    },
    hiddenmenu() {
      this.titlewidth = this.$(".indexwrapheadtitle").width();
      this.titleleftwidth =
        this.$(".titleleft").outerWidth(true) > this.titleleftwidth
          ? this.$(".titleleft").outerWidth(true)
          : this.titleleftwidth;
      this.titlerightwidth =
        this.$(".titleright ").outerWidth(true) > this.titlerightwidth
          ? this.$(".titleright ").outerWidth(true)
          : this.titlerightwidth;
      if (
        this.screenWidth > 767 &&
        this.titlewidth - this.titlerightwidth - this.titleleftwidth < 20
      ) {
        console.log("小于20生效");
        this.$(".titlemenu").show();
        this.$(".titleright li:first").hide();
        this.$(".titleleft ").show();
        this.$(".titleleft a ").css({
          "font-weight": "normal",
          "font-size": "20px",
        });
      } else if (
        this.screenWidth > 767 &&
        this.titlewidth - this.titlerightwidth - this.titleleftwidth > 20
      ) {
        console.log("大于20生效");

        this.$(".titlemenu").hide();
        this.$(".titleright li:first").css("display", "inline-block");
        this.$(".titleleft ").css("display", "inline-block");
        this.$(".titleleft a ").css({
          "font-weight": "600",
          "font-size": "25px",
        });
      }
    },

    // 加购之前
    beforeAdd() {
      // 购物车商品列表的高度
      this.cartItemHeight = this.$('.drawer_inner_main__inner')?.height() || 0;
    },

    // 加购后，要滚动回到物品列表，定位在最后一行
    scrollerBack(product = {}) {
      if (this.cartType !== "drawer") {
        return;
      }

      const { productId } = product

      // 同一个商品加购, 判断购物车里是否有该商品，并计算位置
      const dom = this.$(`[cart-product-id='${productId}']`);

      let height = this.cartItemHeight
      if (productId && dom?.length > 0) {
        height = dom[0].offsetTop
      }

      this.$(".titlerightcart .drawer_inner_main").animate(
        {
          scrollTop: height,
        },
        500
      );
    },

    stickiness(el) {
      let max_top = 0;
      const self = this
      let sectionHeader = $(el);
      if(!sectionHeader.length) return;
      $(window).scroll(function () {
        let top = sectionHeader[0].getBoundingClientRect().top;
        max_top = top > max_top ? top : max_top;
        if ($(window).scrollTop() > 1) {
          self.home_fixd_top = el === '.indexwrapheadtitle' && true
          self.onSuspension = false
          if(self.headerConfig.notice_visibility){
            let marginTop =  self.$('.toptitle')?.[0]?.offsetHeight || 0
            sectionHeader.css({"margin-top":marginTop})
          }
        } else {
          self.home_fixd_top = el === '.indexwrapheadtitle' && false
          self.onSuspension = true
          sectionHeader.css({"margin-top":0})
        }
      })
    }
  },
  beforeMount() {
    if (
      !window.fbq &&
      this.pixel_conversion &&
      this.pixel_conversion.pixel_conversion
    ) {
      this.FBevent();
    }
  },
  mounted() {
    if (this.mainmenu.length) {
      this.titleleftwidth = this.$(".titleleft").outerWidth(true);
      this.hiddenmenu();
      window.addEventListener(
        "resize",
        () => {
          this.hiddenmenu();
        },
        false
      );
    }
    // 是否显示推荐商品
    if (this.recommended_product) {
      this.show_recommended = this.recommended_product.shopCart == 1;
    }
    let top =  this.headerConfig.notice_visibility ? this.$('.toptitle')?.[0]?.offsetHeight - 1 : 0
    this.$el.style.setProperty('--header-notice-height',`${top}px`)
    if (this.headerConfig.visibility == 'float') {
      // position: fixed 会使高度塌陷 滚动条的判断会导致页面抖动
      // 当不是在主页&&在主页显示透明标题时，使用position: sticky
      if( !this.headerConfig?.transparent_head || this.pathName !== '/'){
         this.fixd_top = true
      } else{
        //  当开启 在主页显示透明标题 时，菜单栏悬浮在轮播图上，本身不占用页面高度，
        // 所以使用position: fixed时，不会使高度塌陷
        this.stickiness('.indexwrapheadtitle')
      }
    }
    const bodyWidth = this.$('body')[0].offsetWidth
    this.$el.style.setProperty('--el-width-half', bodyWidth > 1160 ? '-580px' : '-50vw')
  },
  watch: {
    "$store.state.cart_type"() {
      if (this.$store.state.cart_type) {
        this.showCart(0);
      }
    },
    "$store.state.news_cart"(newV) {
      this.cartmes = newV;
    },
  },
  computed: {
    ...mapState({
      headerConfig: ({ options }) => options?.theme?.modules?.header || {},
      showCurrencySelector: ({ options }) => options?.theme?.global?.show_currency_selector,
      theme: ({ options }) => options?.theme?.name,
      currencySelectorType: ({ options }) => options?.theme?.global?.currency_selector_type,
      themeStyleRadius: ({ options }) => options?.theme?.global?.style?.type || "",
      loading: ({ disabled }) => disabled,
      cartNotOff: ({ options }) => options.theme?.pages?.cart?.config?.cart_note || false,
      cartType: ({ options }) => options.theme?.global?.cart?.type || null,
      checkoutMemberConfig: ({ options }) => options.base?.checkout_member_config,
      title: ({ options }) => options.base?.blogname,
      // 屏幕宽度
      screenWidth: ({ screenWidth }) => screenWidth,
      scrollMethod: ({ scrollMethod }) => scrollMethod,
      // 抽屉购物车风格
      cartStyle: ({ options }) => options?.theme?.global?.cart?.style || 'bright',
      cartContentsCount: ({cartContentsCount}) => cartContentsCount,
    }),
    windowScrollY() {
      if(this.headerConfig.visibility == 'float'){
        return false
      }else {
        return window.scrollY > 100
      }
    },
    product_ids() {
      if (!this.cartmes.cart) return;
      let products = Object.values(this.cartmes.cart);
      let ids = [];
      if (!products.length) return "";
      products.forEach((item) => {
        ids.push(item.product_id);
      });
      return ids.join(",");
    },
    complete_subtotal() {
      let subtotal = this.cartmes.cart_total - this.cartmes.shipping_total;
      if (
        this.cartmes.fees &&
        this.cartmes.fees["shipping-insurance"] &&
        this.cartmes.fees["shipping-insurance"].amount
      ) {
        subtotal = subtotal - this.cartmes.fees["shipping-insurance"].amount;
      }
      return subtotal;
    },
    transparentHead() {
      return this.headerConfig?.transparent_head || false
    },
    titleLogo() {
      return this.headerConfig?.logo || null
    },
    logoMaxWidth() {
      return this.headerConfig?.logo_max_width || null
    },
    addCartAnimation() {
      return this.scrollMethod == 'down' && this.loading
    }

  },
  components: {
    vDefaultDrawerCart,
    DrawerMenu
  },
};
</script>

<style lang='scss' scoped>
//权重 110
#app .indexswiper .menu--on-top{
  position: fixed !important;
  top: 0;
  z-index: 99;
  width: 100%;
  max-width: 100% !important;
  padding-left: calc((100% - 1160px) / 2 + 15px) !important;
  padding-right: calc((100% - 1160px) / 2 + 15px) !important;
  @media screen and (max-width: 1165px) {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
  &::v-deep{
    .menu_icon_color {
      color: var(--menu-icon-color) !important;
    }
  }
}

#app .menu--on-top{
  position: sticky !important;
  top: var(--header-notice-height);
  z-index: 99;
  .indexwrapheadtitle{
    z-index: 99;
    width: 100%;
    max-width: 100% !important;
    padding-left: calc((100% - 1160px) / 2 + 15px) !important;
    padding-right: calc((100% - 1160px) / 2 + 15px) !important;
    @media screen and (max-width: 1165px) {
      padding-left: 15px !important;
      padding-right: 15px !important;
    }
    &::v-deep{
      .menu_icon_color {
        color: var(--menu-icon-color) !important;
      }
    }
   }
}

#app .menu-currency-selector-mb {
  display: none;
  @media screen and(max-width: 768px){
    & {
      display: flex;
      position: fixed;
      bottom: 0;
      width: 290px;
      background-color: #f2f2f2;
      padding: 0 15px;
      ::v-deep {
        .selectpricewrap {
          line-height: 52px;
          width: 100%;
          .secondary_title {
             color: #3a3a3a !important;
          }
          .icon-cm-xia {
            float: right;
            transform: rotateZ(180deg);
          }
          .pricelistbox {
            width: 270px !important;
            .pricelist {
              width: calc(100% - 10px);
              margin: 0;
              height: 215px;
              overflow: auto;
              overflow-x: hidden;
              top: -267.5px !important;
              padding: 20px 15px  0  15px!important;
              li {
                max-width: 230px !important;
                width: 100% !important;
                margin-left: 0 !important;
                display: block !important;
              }
            }
          }
        }
      }
    }
    &:active {
        background-color: #f9f9f9;
    }
  }
}

.headbox {
  ul {
    padding: 0;
    li {
      list-style: none;
    }
  }
  a{
    color: inherit;
  }
  .indexwrapheadtitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .titlemenu {
      display: none;
      width: 110px;
      float: left;
      -webkit-tap-highlight-color: rgba(23, 178, 235, 0.3) !important;
      a {
        color: black;
        text-decoration: none;
        font-weight: 600;
        font-style: normal;
        letter-spacing: 0.1em;
        font-size: 30px;
      }

      .icon-cm-cancel-1-copy {
        font-size: 20px;
      }
    }
    .titleleft {
      display: inline-block;
      text-align: center;
      a {
        color: black;
        font-size: 25px;
        font-weight: 600;
        font-style: normal;
        letter-spacing: 0.1em;
        // text-transform: uppercase;
        text-decoration: none;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        img {
          max-width: 180px;
        }
      }
    }

    .titleright {
      float: right;
      margin: 0;
      display: flex;
      .currency-selector {
        .selectpricewrap {
          width: max-content;
          line-height: unset;
        }
      }
      & > li:not(:first-child) {
        padding: 0;
        a, div {
          padding: 0 15px;
        }

      }
      & > li {
        float: left;
        margin: 0;
        padding: 0 7.5px;
        position: relative;
        line-height: 58px;
        .textnav {
          font-size: 14px;
          padding: 0 15px;
          position: relative;
        }
        .has_child_menu {
          & > ul {
            display: none;
            position: absolute;
            background: white;
            top: 58px;
            left: 0;
            min-width: 100%;
            z-index: 99999;
            box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.09);
            li {
              text-align: left;
              line-height: 35px;
              background: white;
              a {
                width: 100%;
                padding: 0 15px;
                letter-spacing: 1px;
                white-space: nowrap;
                color: black;
                font-size: 16px;
              }
            }
          }
          i {
            margin-left: 7.5px;
            color: black;
            font-size: 11px;
            line-height: 1;
            vertical-align: middle;
          }
          &:hover {
            background: white;
            &::before {
              content: "";
              position: absolute;
              left: 15px;
              right: 30px;
              bottom: 4px;
              display: block;
              background-color: #222323;
              height: 1px;
              z-index: 9999;
            }
            & > ul {
              display: block;
              &:hover {
                display: block;
              }
            }
          }
          .has_third_menu {
            &:hover::before {
              display: none;
            }
            & > ul {
              top: 0;
              left: 100%;
              background-color: transparent;
              padding-left: 2px;
            }
          }
        }

        a {
          display: inline-block;
          color: black;
          font-size: 20px;
          text-decoration: none;
          font-style: normal;
          letter-spacing: 2px;
          // text-transform: uppercase;
        }

        .cart_dot {
          position: absolute;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          top: 20px;
          right: 5px;
          display: inline-block;
          background: #a26b25;
        }
        .default_num {
          background-color: #FF7538 !important;
          width: 16px !important;
          height: 16px !important;
          line-height: 16px !important;
          font-size: 12px;
          color: #fff;
          overflow: hidden;
          letter-spacing: normal;
          font-weight: 400;
          text-align: center;
          top: 15px;
          right: 8px;
        }
        .default_num.default_big_num {
            width: 26px !important;
            border-radius: 8px;
            transform: scale(0.9);
            right: 3px;
        }
        @media screen and (max-width: 768px) {
          .default_num {
            width: 14px !important;
            height: 14px !important;
            line-height: 15px !important;
          }
          .default_num.default_big_num {
            width: 28px !important;
            border-radius: 7px;
            left: 15px !important;
          }
        }
      }
    }
  }

  #titlemenrlistDefault{
    width: 300px;
    left: -300px;
    font-size: 16px;
    li{
      a{
        color: #666666;
      }
    }
    .titlemainmenu{
      a{
        color: #222222;
      }
    }
  }
  //首页head的样式
  .indexmodule {
    position: absolute !important;
    top: 0 !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    z-index: 80;
  }
}

.Masked {
  background: white;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  .searchinput {
    width: 300px;
    position: absolute;
    margin: auto;
    top: 40vh;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 20;
    display: flex;
    input {
      width: 10px;
      border: none;
      height: 45px;
      flex: 1;
      padding: 8px 10px;
      background: #f6f6f6;
      font-size: 18px;
    }
    span {
      text-align: center;
      width: 56px;
      height: 45px;
      line-height: 45px;
      background: #c90d0d;
      color: white;
      border: none;
      font-size: 12px;
      cursor: pointer;
    }
    i {
      position: fixed;
      right: 50px;
      top: 30px;
      font-weight: bolder;
      cursor: pointer;
    }
  }
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease;
}

@media screen and (max-width: 768px) {
  .indexwrapheadtitle {
    .titlemenu {
      width: 40px !important;
      display: block !important;
      margin-left: -5px;
      a {
        padding: 5px 3.5px;
        font-size: 20px !important;
      }
    }

    .titleleft {
      display: inline-block;
      a {
        font-weight: normal !important;
        font-size: 20px !important;
        img {
          max-width: 65px !important;
        }
      }
    }

    .titleright {
      li {
        a {
          padding: 0 !important;
          margin-right: -9px;
          &::before {
            padding: 9.5px 9px;
          }
          .cart_dot {
            right: -4px !important;
          }
        }
      }
      li:not(:last-child) {
        display: none !important;
      }

      .icon-gwc {
        font-size: 25px !important;
      }
    }
  }
}
#app .animation-product-to-cart {
  display: block !important;
  position: absolute;
  padding: 0;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  .xAxis {
    padding: 0;
    transform: translateX(calc(var(--el-width-half) + 50%));
    animation: xAxis 0.5s 1 cubic-bezier(0.39,0.43,0.58,0.61) forwards;
    .yAxis {
      transform: translateY(calc(50vh - 150%));
      animation: yAxis 0.5s 1 cubic-bezier(0.27,0.59,0.41,0.74) forwards;
    }

  }
  @keyframes xAxis {
    100% {
      transform: translateX(0);
    }
  }
  @keyframes yAxis {
    99% {
      opacity: 1;
    }
    100% {
      transform: translateY(0);
      opacity: 0;
    }
  }
}


</style>
